<template>
<div>
	<el-dialog title="修改资料" class="dialog-header-line" :visible.sync="visible" width="560px">
		<el-form size="small" ref="editForm"
			label-position="left" label-width="80px"
			:model="form" :rules="rules">
			<el-form-item label="昵称" prop="nick_name">
				<el-input placeholder="请输入昵称" v-model="form.nick_name" show-word-limit maxlength="16"></el-input>
			</el-form-item>
			<el-form-item label="个性签名" proo="signature">
				<el-input placeholder="请输入个性签名" type="textarea" resize="none" :rows="4"
					 v-model="form.signature"  show-word-limit maxlength="100"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button class="btn" size="small" @click="visible = false">取消</el-button>
			<el-button class="btn" size="small" @click="sumbitBtn" type="danger">确定</el-button>
		</div>
	</el-dialog>
</div>
</template>

<script>
	export default {
		data(){
			let rules = {
				nick_name:[{
					validator:(rule,val,call)=>{
						if(!val){
							call(new Error("昵称不能为空"))
						}else{
							call()
						}
					}
				}],
				signature:(rule,val,call)=>{
					if(!val){
						call(new Error("个性签名不能为空"))
					}else{
						call()
					}
				}
			}
			return {
				visible:false,
				callFn:null,
				rules,	
				form:{
					nick_name:'',
					signature:'',
				}
			}
		},
		created(){
			
		},
		mounted(){
			
		},
		methods: {
			open(data,callFn){
				// console.log(data);
				this.form.nick_name = data.nick_name;
				this.form.signature = data.signature;
				this.visible = true;
				this.callFn = callFn;
			},
			sumbitBtn(data){
				this.$refs.editForm.validate((valid)=>{
					if(valid){
						this.$axios.putJSON("/base/user/info",this.form).then((res) => {
						  if (res.code == 200) {
								this.$message.success("修改成功");
								this.visible = false;
						    this.callFn && this.callFn(this.$utils.cloneDeep(this.form))
						  }
						});
					}
				})
			}
		},
	}
</script>

<style scoped lang="scss">
.dialog-footer{
	text-align: center;
	.btn{
		width:80px;
	}
}
</style>
